import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'
import { MenuItem, TextField } from '@material-ui/core'
import { map, get, sortBy } from 'lodash'

import { Box, Typography } from '@material-ui/core'

import api from 'common/api'
import SendChat from 'components/SendChat'
import { selectUserId } from 'store/user'

const SchoolMessage = ({ highSchoolId, highSchoolName, contactUserId }) => {
  const [contacts, setContacts] = useState([])
  const [selected, setSelected] = useState()
  const userId = useSelector(selectUserId)
  useEffect(() => {
    api.get(`/api/highschools/${highSchoolId}/contacts`).then((contacts) => {
      setContacts(contacts)
    })
  }, [highSchoolId])
  return (
    <Fragment>
      <Box
        display="flex"
        alignItems="center"
      >
        <TextField
          select
          id="school-message-comp-contacts"
          margin="normal"
          label="To:"
          value={selected?.UserId ?? ''}
          onChange={(e) => {
            const contact = (contacts ?? []).find((c) => c.UserId === e.target.value)
            setSelected(contact)
          }}
          variant="outlined"
          fullWidth
        >
          <MenuItem value="">Select a counselor to contact</MenuItem>
          {map(
            sortBy(contacts, (contact) => contactUserId !== contact.UserId),
            (contact) => (
              <MenuItem
                key={contact.UserId}
                value={contact.UserId}
              >
                {`${[contact.FirstName, contact.LastName].join(' ')}`}
                {contactUserId === contact.UserId && (
                  <Typography
                    component="span"
                    color="textSecondary"
                  >
                    &nbsp;- primary contact
                  </Typography>
                )}
              </MenuItem>
            ),
          )}
        </TextField>
      </Box>
      <Box
        borderTop="1px solid #eee"
        my={3}
        pt={3}
      >
        <SendChat
          disabled={!selected}
          userId={userId}
          recipient={{
            userId: get(selected, 'UserId'),
            firstName: get(selected, 'FirstName'),
            lastName: get(selected, 'LastName'),
            school: highSchoolName,
          }}
        />
      </Box>
    </Fragment>
  )
}
SchoolMessage.propTypes = {
  highSchoolId: PropTypes.string.isRequired,
  highSchoolName: PropTypes.string.isRequired,
  contactUserId: PropTypes.string,
}

export default SchoolMessage
